/**
 * Paleta por marca de impressora — borda/cabeçalho dos blocos e Chip do nome.
 * Marcas sem match usam um accent neutro (ainda com contraste na lista).
 */
export function getPrinterBrandPalette(brand) {
    const key = String(brand || '').trim().toLowerCase();

    if (key.includes('creality')) {
        return {
            accent: '#2e7d32',
            soft: 'rgba(46, 125, 50, 0.12)',
            chip: { color: 'success' },
        };
    }

    if (key.includes('anycubic')) {
        return {
            accent: '#2746b8',
            soft: 'rgba(39, 70, 184, 0.14)',
            chip: {
                sx: {
                    bgcolor: '#2746b8',
                    color: '#fff',
                    fontWeight: 600,
                },
            },
        };
    }

    if (key.includes('flashforge') || key.includes('flash forge')) {
        return {
            accent: '#0288d1',
            soft: 'rgba(2, 136, 209, 0.12)',
            chip: { color: 'info' },
        };
    }

    if (key.includes('bambu')) {
        return {
            accent: '#757575',
            soft: 'rgba(117, 117, 117, 0.16)',
            chip: {
                sx: {
                    bgcolor: '#9e9e9e',
                    color: '#fff',
                    fontWeight: 600,
                },
            },
        };
    }

    return {
        accent: '#5c6bc0',
        soft: 'rgba(92, 107, 192, 0.12)',
        chip: null,
    };
}

/** Props para MUI Chip do nome da impressora conforme a marca. */
export function getPrinterBrandBadgeProps(brand) {
    return getPrinterBrandPalette(brand).chip;
}
